<script lang="ts">
  import Icon from './Icon.svelte';

  let {
    compact = false,
    errorMessage,
    showHelp = true,
  }: {
    compact?: boolean;
    /** Optional error message rendered above the help. */
    errorMessage?: string;
    /** Hide the expandable help (e.g. when the failure isn't permission-related). */
    showHelp?: boolean;
  } = $props();
</script>

<div class="wrap" class:compact>
  {#if errorMessage}
    <p class="error">{errorMessage}</p>
  {/if}
  {#if showHelp}
    <details class="help">
      <summary>
        <Icon name="info" size={13} strokeWidth={2.25} />
        <span>Why isn't my location used?</span>
      </summary>
      <ul>
        <li>Allow location for this site in your browser's site settings.</li>
        <li>
          On macOS, enable Location Services for your browser in
          <span class="path">System Settings → Privacy &amp; Security → Location Services</span>.
        </li>
        <li>Private browsing windows often block location.</li>
      </ul>
    </details>
  {/if}
</div>

<style>
  .wrap {
    display: flex;
    flex-direction: column;
    gap: 0.375rem;
  }
  .error {
    margin: 0;
    font-size: 13px;
    color: var(--color-error);
  }
  .compact .error { font-size: 12px; }
  .help {
    font-size: 13px;
    color: var(--color-muted);
    line-height: 1.5;
  }
  .compact .help { font-size: 12px; }
  summary {
    display: inline-flex;
    align-items: center;
    gap: 0.375rem;
    cursor: pointer;
    color: var(--color-body);
    list-style: none;
    user-select: none;
  }
  summary::-webkit-details-marker { display: none; }
  summary:hover { color: var(--color-ink); }
  ul {
    margin: 0.5rem 0 0 0;
    padding: 0 0 0 1.125rem;
  }
  ul li + li { margin-top: 0.25rem; }
  .path {
    font-family: var(--font-mono, ui-monospace, SFMono-Regular, Menlo, monospace);
    font-size: 0.92em;
    color: var(--color-body);
  }
</style>
